import React from "react";
import "../../components/Themes/styles/themes.css";
import "./styles/admin-button.css";
import { useAdmin } from "./AdminProvider";

const AuthButton = () => {
  const { adminPanelOpen, toggleAdminPanel, loading, user } = useAdmin();

  const handleClick = () => {
    toggleAdminPanel();
  };

  return (
    <>
      <button
        title={adminPanelOpen ? "Close Panel" : "Open Admin Panel"}
        type="button"
        className="themes__button auth-button"
        style={{
          top: "9.5rem",
          overflow: user && !adminPanelOpen ? "hidden" : undefined,
          border:
            (user || loading) &&
            !adminPanelOpen &&
            "3px solid var(--text-color)",
          width: user && !adminPanelOpen ? "41px" : "45px",
          height: user && !adminPanelOpen ? "45px" : "47px",
          right: user && !adminPanelOpen ? "18px" : "16px",
        }}
        onClick={handleClick}
        disabled={loading}
      >
        {loading ? (
          <i
            className="uil uil-spinner themes__icon"
            style={{ animation: "spin 1s linear infinite" }}
          ></i>
        ) : adminPanelOpen ? (
          <i className="bx bx-x themes__icon"></i>
        ) : user && user.photoURL ? (
          <img
            src={user.photoURL}
            alt="Profile"
            className="auth-button__profile-pic"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "50%",
              display: "block",
            }}
          />
        ) : (
          <i className="bx bx-user-circle themes__icon"></i>
        )}
      </button>
    </>
  );
};

export default AuthButton;
